import './shipping-notification.scss';

const { shippingNotificationTexts } = window.mamasplatz.product;

(() => {
  const shippingNotificationEl = document.querySelector(
    '.ShippingNotification',
  );

  if (!shippingNotificationEl) return;

  document.addEventListener('variant:changed', ({ detail: { variant } }) => {
    // `variant` could theoretically be `undefined` if a certain option combination was selected
    // that does not exist as a variant. In this case we return early.
    if (!variant) return;

    const { available } = variant;

    shippingNotificationEl.textContent = available
      ? shippingNotificationTexts.available
      : shippingNotificationTexts.sold_out;

    shippingNotificationEl.classList.toggle(
      'ShippingNotification--Available',
      available,
    );
    shippingNotificationEl.classList.toggle(
      'ShippingNotification--SoldOut',
      !available,
    );
  });
})();
